import React from "react";
import "../index.css";
import { useNavigate } from "react-router";
import backIcon from "../../../img/Arrow.png";
import AddAddress from "../../../Store/Cart/Components/Modals/AddAddress";
const AddNewAddress = () => {
  const navigate = useNavigate();

  return  (
    <div className="ma1">
      <div className="ma2 fixed-top d-flex align-items-center transition text-orange bg-white ">
        <div className="text-center my-auto ma3">
          <img src={backIcon} alt="" width={24} onClick={() => navigate(-1)} />
        </div>
        <div className="w-100 my-auto overflow-hidden">
          <h2 className="ma4">Add Address</h2>
        </div>
      </div>

          <div className="bg-white address-card">
            <div className="d-flex align-items-center justify-content-between sec-title">
              <h2 className="ma5">Delivery Address</h2>
            </div>
            
            <AddAddress navigateTo={navigate}/>
          </div>
          <div className="bottom-bar">  
 
          </div>
    </div>
  ) 
};
export default AddNewAddress;
